var PlaylistItem             = require("./PlaylistItem"),
    RepeaterArrayDataAdapter = require("enyo-ui/RepeaterArrayDataAdapter"),
    SimpleRepeater           = require("enyo-ui/SimpleRepeater"),
    frameThrottle            = require("enyo-perf/utils").frameThrottle,
    get                      = require("object-path").get,
    kind                     = require("enyo/kind");

require("./Playlist.less");

module.exports = kind(/** @lends app.ArtistPage.Playlist.prototype */ {

    /**
     * @private
     */
    name: "app.ArtistPage.Playlist",

    /**
     * @private
     */
    classes: "app-artist-page-playlist",

    /**
     * The data of this playlist.
     *
     * @type  {?Object}
     * @public
     */
    data: null,

    /**
     * @private
     */
    components: [{
        name:    "title",
        classes: "app-artist-page-playlist__title",
        tag:     "h2"
    }, {
        name:            "playlist",
        kind:            SimpleRepeater,
        classes:         "app-artist-page-playlist__playlist",
        tag:             "table",
        dataAdapterKind: RepeaterArrayDataAdapter,
        childKind:       PlaylistItem
    }],

    /**
     * @private
     */
    observers: {
        update: ["data"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.update();
        };
    }),

    /**
     * @protected
     */
    update: function() {
        var data = this.data || {};

        this.$.title.set("content", get(data, "meta.title", null) || "");
        this.$.playlist.set("data", get(data, "category_content", []));
    }

});
